"use strict";

var _taggedTemplateLiteral = require("/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject;

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

const styled_components_1 = __importDefault(require("styled-components"));

const Input_1 = __importDefault(require("../input/Input"));

const TextInput = styled_components_1.default(Input_1.default).attrs({
  type: 'text'
})(_templateObject || (_templateObject = _taggedTemplateLiteral([""])));
exports.default = TextInput;